import { render, staticRenderFns } from "./ActionPostBackTypeFlexMessage.vue?vue&type=template&id=3da770a2&scoped=true&"
import script from "./ActionPostBackTypeFlexMessage.vue?vue&type=script&lang=js&"
export * from "./ActionPostBackTypeFlexMessage.vue?vue&type=script&lang=js&"
import style0 from "./ActionPostBackTypeFlexMessage.vue?vue&type=style&index=0&id=3da770a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da770a2",
  null
  
)

export default component.exports